import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

/* The ways to start: one card each, apart, as the lists on /domains */
export const Options = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 720px;
  padding: 1.5rem 2rem 2rem;

  &,
  & * {
    font-family: Inter, sans-serif;
  }

  @media ${MOBILE} {
    padding: 20px;
  }
`;

/* A way to start: emoji, title and description, chevron. The AI's ($main): the brand's green glow and border */
export const Option = styled.button<{ $main?: boolean }>`
  display: flex;
  gap: 1.25rem;
  align-items: center;
  width: 100%;
  padding: ${({ $main }) => ($main ? "1.25rem 1.25rem 1.25rem 1rem" : "1rem 1.25rem 1rem 1rem")};
  text-align: left;
  background: ${({ $main }) =>
    $main
      ? "radial-gradient(120% 160% at 0% 0%, rgba(87, 242, 139, 0.14), transparent 60%), var(--color-neutral-dark)"
      : "var(--color-neutral-dark)"};
  border: 1px solid ${({ $main }) => ($main ? "rgba(87, 242, 139, 0.35)" : "transparent")};
  border-radius: 1rem;
  transition: border-color 0.15s;

  &:hover {
    border-color: ${({ $main }) => ($main ? "var(--color-brand-plus)" : "var(--color-neutral-base)")};
  }

  &:focus-visible {
    outline: 2px solid var(--color-brand-blue);
    outline-offset: 2px;
  }

  @media ${MOBILE} {
    gap: 1rem;
    padding: 1rem;
  }

  .emoji {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    font-size: 1.5rem;
    background: ${({ $main }) => ($main ? "rgba(87, 242, 139, 0.15)" : "var(--color-neutral-darkness)")};
    border-radius: 12px;

    @media ${MOBILE} {
      width: 48px;
      height: 48px;
      font-size: 1.25rem;
    }
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
  }

  .title {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
    font-size: ${({ $main }) => ($main ? "1.0625rem" : "0.9375rem")};
    font-weight: 700;
    color: var(--color-neutral-white);
  }

  .description {
    font-size: 0.8125rem;
    line-height: 1.125rem;
    color: var(--color-neutral-150);
  }

  .chevron {
    flex-shrink: 0;
    color: ${({ $main }) => ($main ? "var(--color-brand-plus)" : "var(--color-neutral-150)")};
  }
`;
